export default "__VITE_ASSET__55ca7c5c__"